import { useBrowsePresetApi } from '@aibees/shared/api';
import { Nullable, ParsedPreset } from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { jsonParseSafe } from '@aibees/shared/utils';

export type GetSinglePresetRequest = { type: string; name?: string | null };

export function useGetSinglePresetApi<T = unknown>(
  params: GetSinglePresetRequest,
  options?: QueryOptions
) {
  const api = useBrowsePresetApi<T>({ ...params, page: 0, size: 1 }, options);

  // this condition added because options onSuccess in useBrowsePresetApi doesn't allway return parsed value
  if (typeof api.data?.content?.[0]?.value === 'string') {
    return {
      ...api,
      data: {
        ...api.data?.content?.[0],
        value: jsonParseSafe(api.data?.content?.[0].value),
      } as Nullable<ParsedPreset<T>>,
    };
  }

  return {
    ...api,
    data: (api.data?.content?.[0] || null) as Nullable<ParsedPreset<T>>,
  };
}
